import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function register(email, password) {
  const res = await api.post("/register", { email, password });
  return res.data;
}
export async function login(email, password) {
  const res = await api.post("/login", { email, password });
  return res.data;
}
export async function getCurrentUser() {
  const res = await api.get("/user/me");
  return res.data;
}
export async function getSnippets() {
  const res = await api.get("/snippets");
  return res.data;
}
export async function addSnippet(keyword, content) {
  const res = await api.post("/admin/add_snippet", { keyword, content });
  return res.data;
}
export async function updateSnippet(keyword, content) {
    const res = await api.patch("/admin/update_snippet", { keyword, content });
    return res.data;
  }

export async function deleteSnippet(keyword) {
    const res = await api.delete("/admin/delete_snippet", { data: { keyword } });
    return res.data;
  }
  
